import { type KeyboardEvent } from 'react'
import { ArrowUpRight as ArrowUpRightIcon } from '@phosphor-icons/react/dist/ssr/ArrowUpRight'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import { useTypeformNav } from '@/contexts/typeform-nav-context'

interface NavTypeformItemProps {
	typeformId: string
	title?: string
	depth: number
	mini?: boolean
	onClose?: () => void
}

export function NavTypeformItem({ typeformId, title, depth, mini, onClose }: NavTypeformItemProps) {
	const { openTypeform } = useTypeformNav()

	const openForm = () => {
		openTypeform({ formId: typeformId, onNavClose: onClose })
	}

	const handleKeyUp = (event: KeyboardEvent<HTMLDivElement>) => {
		if (event.key === 'Enter' || event.key === ' ') {
			openForm()
		}
	}

	return (
		<Box component="li" data-depth={depth} sx={{ userSelect: 'none' }}>
			<Box
				className="SideNav-navItem"
				onClick={openForm}
				onKeyUp={handleKeyUp}
				role="button"
				tabIndex={0}
				sx={{
					alignItems: 'center',
					borderRadius: 1,
					color: 'var(--NavItem-color)',
					cursor: 'pointer',
					display: 'flex',
					flex: '0 0 auto',
					gap: 1,
					p: '6px 16px',
					position: 'relative',
					textDecoration: 'none',
					whiteSpace: 'nowrap',
					'&:hover': {
						bgcolor: 'var(--NavItem-hover-background)',
						color: 'var(--NavItem-hover-color)',
					},
				}}
			>
				<Box sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flex: '0 0 auto' }} />
				<Box sx={{ flex: '1 1 auto', height: '28px', minWidth: 0 }}>
					{!mini ? (
						<Typography
							component="span"
							noWrap
							sx={{ color: 'inherit', fontSize: '0.875rem', fontWeight: 500, lineHeight: '28px' }}
						>
							{title}
						</Typography>
					) : null}
				</Box>
				{!mini && depth > 0 ? (
					<Box
						aria-hidden
						sx={{
							alignItems: 'center',
							display: 'flex',
							flex: '0 0 auto',
							ml: 'auto',
							visibility: 'hidden',
						}}
					>
						<ArrowUpRightIcon fontSize="var(--icon-fontSize-sm)" />
					</Box>
				) : null}
			</Box>
		</Box>
	)
}
